import type { AttributeFilters } from '@ipfabric/utils';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { globalAttributeFiltersLocalStorage } from '../globalAttributeFiltersLocalStorage';

interface SetGlobalAttributeFiltersCommand {
  attributeFilters: AttributeFilters;
}

export const setGlobalAttributeFilters: GlobalStateCommandFactory<
  SetGlobalAttributeFiltersCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.attributeFilters = command.attributeFilters;
  });

  globalAttributeFiltersLocalStorage.set(command.attributeFilters);
};
